import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5bd94f38"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./index.sass?vue&type=style&index=0&prod&lang=sass&external"
import style1 from "./list.vue?vue&type=style&index=1&id=5bd94f38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports